import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { Skeleton } from '@/components/ui/skeleton';
import { getFeaturedSessionGroupsOptions } from '@/api/generated/@tanstack/react-query.gen';
import { SessionGroupCard } from '@/components/Learn/SessionGroupCard';

export const Route = createFileRoute('/_auth/explore')({
  component: ExplorePage,
});

function ExplorePage() {
  const { data: featured = [], isLoading } = useQuery({
    ...getFeaturedSessionGroupsOptions(),
    staleTime: 5 * 60 * 1000,
  });

  return (
    <section className="mx-auto w-full max-w-5xl pt-4 sm:pt-8">
      <h1 className="text-[26px] font-semibold tracking-[-0.03em] text-neutral-900">
        Explore
      </h1>
      <p className="mt-1 text-[15px] text-neutral-600">
        Hand-picked sessions to try right now.
      </p>

      <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {isLoading
          ? Array.from({ length: 6 }).map((_, i) => (
              <Skeleton key={i} className="aspect-[4/3] rounded-2xl" />
            ))
          : featured.map((group) => (
              <SessionGroupCard key={group.id} group={group} />
            ))}
      </div>

      {!isLoading && featured.length === 0 && (
        <p className="mt-10 text-center text-[15px] text-neutral-600">
          Nothing here yet. Check back soon.
        </p>
      )}
    </section>
  );
}
